import { QTag, QTagProps } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ChangeRequestStatusProps = {
  status: string;
};

export const CHANGE_REQUEST_STATUSES = [
  {
    name: 'draft',
    textKey: 'statuses.draft',
    tagColor: 'default',
  },
  {
    name: 'for_approval',
    textKey: 'statuses.forApproval',
    tagColor: 'blue',
  },
  {
    name: 'approval_declined',
    textKey: 'statuses.approvalDeclined',
    tagColor: 'red',
  },
  {
    name: 'in_progress',
    textKey: 'changeRequest.inProgress',
    tagColor: 'blue',
  },
  {
    name: 'closed',
    textKey: 'changeRequest.closed',
    tagColor: 'green',
  },
  {
    name: 'attention_required',
    textKey: 'changeRequest.attentionRequired',
    tagColor: 'yellow',
  },
] as const;

export enum ChangeRequestStatusEnum {
  DRAFT = 'draft',
  IN_PROGRESS = 'in_progress',
  CLOSED = 'closed',
  FOR_APPROVAL = 'for_approval',
  APPROVAL_DECLINED = 'approval_declined',
  ATTENTION_REQUIRED = 'attention_required',
}

export const ChangeRequestStatus: React.FC<ChangeRequestStatusProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  const changeRequestStatus =
    CHANGE_REQUEST_STATUSES.find((crStatus) => crStatus.name === status) ??
    CHANGE_REQUEST_STATUSES[0];

  return (
    <QTag
      data-cy={`cc-status-${changeRequestStatus.name}`}
      variantColor={changeRequestStatus.tagColor as QTagProps['variantColor']}
    >
      {t(changeRequestStatus.textKey)}
    </QTag>
  );
};
